import styled, { keyframes } from 'styled-components';
import { FlexView, Row, COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

export const Root = styled.div`
  display: flex;
  min-height: calc(100vh - 58px);
  height: fit-content;
`;

export const StudentDetails = styled.div`
  width: 100%;
  padding: 20px 24px;
`;

export const StudentDetailsWrapper = styled.div`
  min-width: 336px;
  width: 336px;
  border-right: 1px solid ${COLORS.GHOST};
  background: ${COLORS.BG_CLOUD_LIGHT};
`;

export const StudentNameHeading = styled(Text)`
  max-width: 192px;
  overflow-wrap: break-word;
`;

export const ChipViewWrapper = styled(Row)`
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const ChipView = styled(Row)`
  border: 1px solid ${COLORS.GHOST};
  border-radius: 2px;
  padding: 4px 8px;
  min-width: 140px;
  margin-bottom: 6px;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : 0)};
  flex: 1;
`;

export const ChipLogo = styled.img`
  width: 20px;
  height: 20px;
`;

export const ChipText = styled(Text)`
  margin-left: 4px;
`;

export const VerticleLine = styled.span`
  border-right: 1.5px solid #e0e0e0;
  margin: 0 5px;
`;

export const POCWrapper = styled.div`
  margin-top: 18px;
`;

export const POCHeading = styled(Text)`
  min-width: 84px;
  margin-right: 16px;
  color: rgba(43, 43, 43, 0.75);
  line-height: 20px;
  margin-bottom: 12px;
  cursor: ${({ cursor }) => (cursor ? cursor : 'default')};
  width: ${({ width }) => (width ? width : 'auto')};
  text-decoration: ${({ textDecoration }) => textDecoration || 'none'};
`;

export const POCValue = styled(Text)`
  text-transform: capitalize;
  color: #2b2b2b;
  margin-bottom: 4px;
  text-decoration: ${({ textDecoration }) => (textDecoration ? textDecoration : 'none')};
  cursor: ${({ textDecoration }) =>
    textDecoration === 'underline' ? 'pointer' : 'default'};
`;

export const HorizontalLine = styled.span`
  border-bottom: 1px solid #e0e0e0;
  width: 100%;
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '24px')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '16px')};
  display: block;
`;

export const CardView = styled(FlexView)`
  background: ${COLORS.WHITE};
  border-radius: 8px;
  padding: 12px 0;
  min-width: 140px;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : 0)};
`;

export const StudentIdHeading = styled(Row)`
  font-weight: 700;
`;

export const BorderedBox = styled(Row)`
  border: 1px solid ${COLORS.GHOST};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '8px')};
  padding: ${({ padding }) => (padding ? padding : '8px')};
  margin-top: ${({ marginTop }) => (marginTop ? marginTop : '8px')};
  flex: 1;
  height: fit-content;
  position: relative;
`;

export const StudentDetailsRoutesWrapper = styled.div`
  padding: 16px;
  width: 100%;
`;
export const DetailsRoutesWrapper = styled.div`
  padding: 16px;
  width: 100%;
`;

export const FadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ListView = styled.ul`
  list-style: disc;
  margin: 8px 24px;
`;

export const LoaderContainer = styled.div`
  width: 100%;
  height: calc(100vh - 58px);
  margin: auto;
  display: flex;
  align-items: center;
`;

export const DetailsWrapper = styled.div`
  min-width: 336px;
  width: 336px;
  border-right: 1px solid ${COLORS.GHOST};
  background: ${COLORS.BG_CLOUD_LIGHT};
`;
